import axios from 'axios'
import { getToken, clearAuth } from '@/utils/auth.js'

// 根据环境设置 baseURL
// - 优先使用构建时注入的 VUE_APP_API_BASE_URL（前后端分离部署时使用）
// - 未配置时统一使用相对路径 /api，由开发服务器或 nginx 反向代理到后端
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'

const request = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    console.log('Request:', config.method?.toUpperCase(), config.url, config.baseURL)
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response?.status === 401) {
      clearAuth()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default request
